import { SlideController } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/slide-controller'].update({
        staticData: { title: { page: 'Title.SlideController', forWebinar: true } },
        component: authGuard(SlideController, { canBroadcast: true })
    });
};
